import { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
// redux
import { useDispatch, useSelector } from 'src/redux/store';
import { getShopsList } from 'src/redux/slices/shops';
import { setCurShopId } from 'src/redux/slices/startform';
// routes
import { paths } from 'src/routes/paths';
// components
import EmptyContent from 'src/components/empty-content';
import ShopSwitchDialog from 'src/components/shop-select/ShopSwitchDialog';

// ----------------------------------------------------------------------

export default function EmptyShopSelection() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { current_shop: shops } = useSelector((state) => state.shops);

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!shops.length) {
            dispatch(getShopsList());
        }
    }, [dispatch, shops.length]);


    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChangeShop = useCallback(
        (shopId) => {
            handleClose();
            try { dispatch(setCurShopId(shopId)); } catch (e) {}
            navigate(paths.dashboard.courses.root(shopId));
        },
        [navigate, dispatch]
    );

    return (
        <Container component="main" maxWidth="md" sx={{ mt: 10 }}>
            <Box
                sx={{
                    py: 10,
                    borderRadius: 2,
                    border: (theme) => `dashed 1px ${theme.palette.divider}`,
                    bgcolor: (theme) => theme.palette.background.neutral,
                }}
            >
                <EmptyContent
                    title="Магазин не выбран"
                    description="Чтобы продолжить работу с курсами, пожалуйста, выберите магазин."
                    action={
                        <Button
                            variant="contained"
                            color="inherit"
                            onClick={handleOpen}
                            sx={{ mt: 3 }}
                        >
                            Выбрать магазин
                        </Button>
                    }
                />
            </Box>

            <ShopSwitchDialog
                open={open}
                onClose={handleClose}
                shops={shops}
                currentShopId=""
                onChangeShop={handleChangeShop}
            />
        </Container>
    );
}
